import { Dispatch, SetStateAction, useEffect, useState } from 'react';
import axios from 'axios';
import Box from '@mui/material/Box';
import moment from 'moment';
import AlertMui from '../../../../components/common/AlertMui';

import { SubmitButton } from '../../../../components/common/button/CustomButtons';
import InputMuiCustom from '../../../../components/common/inputs/InputMuiCustom';
import FormControlMui, {
  StyledField,
} from '../../../../components/common/FormControlMui';
import DatePickerMui from '../../../../components/common/DatePickerMui';
import useConfirm from '../../../../components/common/useConfirm';
import AutocompleteMuiCustom from '../../../../components/common/AutocompleteMuiCustom';
interface Iprop {
  setIsNewPartModal: Dispatch<SetStateAction<boolean>>;
  id?: string | object | null;
  setPartId: React.Dispatch<React.SetStateAction<string | null>>;
}

interface Vendor {
  vender_name: string;
}

export interface IPart {
  _id?: string;
  uom?: string | null;
  type?: string | null;
  part_name?: string | null;
  part_name_2?: string;
  part_number?: string;
  vendor_id?: Vendor;
  vendor_id_2?: Vendor;
  vendor_id_3?: Vendor;
  date_orig?: moment.Moment;
  createdAt?: Date;
}

const AddEditPart = ({ setIsNewPartModal, id, setPartId }: Iprop) => {
  const [partData, setPartData] = useState<IPart>({
    date_orig: moment(),
  });
  const [isLoading, setIsLoading] = useState(false);
  const [supplierData, setSupplierData] = useState([]);
  const [render, setRender] = useState(false);
  const [alert, setAlert] = useState(false);
  const [DialogSubmit, confirmSubmit] = useConfirm(
    'DRAFT PART',
    `Are you sure you want to ${id ? 'update' : 'save'} this part?`,
  );

  const handlePartData = (e: React.ChangeEvent<HTMLInputElement>): void => {
    setPartData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  useEffect(() => {
    axios
      .get('/api/vendorRoute/')
      .then((res) => {
        setSupplierData(res.data.results);
      })
      .catch((err) => console.log(err));
  }, []);

  useEffect(() => {
    if (id) {
      axios
        .get(`/api/riDepartment/riPart/${id}`)
        .then((res) => {
          setPartData(res.data);
        })
        .catch((err) => console.log(err));
    } else {
      setPartData((prev) => prev);
    }
  }, [id]);

  const onSubmit = async (e: any) => {
    e.preventDefault();
    const ans = await confirmSubmit();
    if (!ans) return;
    setIsLoading(true);
    if (id) {
      await axios
        .put(`/api/riDepartment/riPart/${id}`, partData)
        .then((res) => {
          setIsLoading(false);
          setIsNewPartModal(false);
          setPartId(null);
        })
        .catch((err) => {
          console.log(err);
          setIsLoading(false);
        });
    } else {
      await axios
        .post('/api/riDepartment/riPart', partData)
        .then((res) => {
          setIsLoading(false);
          setIsNewPartModal(false);
          setPartId(null);
        })
        .catch((err) => {
          console.log(err);
          setIsLoading(false);
        });
    }
  };

  return (
    <>
      <Box>
        <FormControlMui handleSubmit={onSubmit}>
          <div
            className="btn_save"
            style={{
              position: 'absolute',
              right: '140px',
              top: '-0.6px',
            }}
          >
            <SubmitButton
              label={`${id ? 'update' : 'submit'}`}
              type="submit"
              disabled={isLoading}
            />
          </div>
          <StyledField>
            <InputMuiCustom
              type="text"
              name="part_name"
              placeholder="Material Name"
              required={true}
              onChange={handlePartData}
              value={partData?.part_name || ''}
            />
            <InputMuiCustom
              type="text"
              name="part_name_2"
              placeholder="Part Name"
              required={true}
              onChange={handlePartData}
              value={partData?.part_name_2 || ''}
            />
            <InputMuiCustom
              type="text"
              name="part_number"
              placeholder="Part Number"
              required={true}
              onChange={handlePartData}
              value={partData?.part_number || ''}
            />
            <AutocompleteMuiCustom
              id="Vendor"
              label="Vendor"
              option_name="vender_name"
              arrayofObj={supplierData}
              value={partData.vendor_id || ''}
              onChange={(e, value) => {
                partData.vendor_id = value;
                setRender((prev) => !prev);
              }}
            />
            <AutocompleteMuiCustom
              id="Vendor2"
              label="Vendor 2"
              option_name="vender_name"
              arrayofObj={supplierData}
              value={partData.vendor_id_2 || ''}
              onChange={(e, value) => {
                partData.vendor_id_2 = value;
                setRender((prev) => !prev);
              }}
            />
            <AutocompleteMuiCustom
              id="Vendor3"
              label="Vendor 3"
              option_name="vender_name"
              arrayofObj={supplierData}
              value={partData.vendor_id_3 || ''}
              onChange={(e, value) => {
                partData.vendor_id_3 = value;
                setRender((prev) => !prev);
              }}
            />
            <InputMuiCustom
              type="text"
              name="uom"
              placeholder="UOM"
              onChange={handlePartData}
              value={partData?.uom || ''}
            />
            <InputMuiCustom
              type="text"
              name="type"
              placeholder="Type"
              onChange={handlePartData}
              value={partData?.type || ''}
            />
            {/* <DatePickerMui
              label="DATE (Original)"
              onChange={(date) => {
                partData.date_orig = date;
                setRender((prev) => !prev);
              }}
              value={moment(partData.date_orig) || null}
            /> */}
          </StyledField>
        </FormControlMui>
      </Box>
      <DialogSubmit />
      <AlertMui
        alert={alert}
        message={
          'Please select a customer from the list. The customer field cannot be left empty'
        }
        setAlert={setAlert}
        severity={'warning'}
      />
    </>
  );
};

export default AddEditPart;
